import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

interface Supplier {
  id: number;
  name: string;
  logo: string;
  description: string;
  country: string;
  category: string;
}

@Component({
  selector: "app-vendor-page",
  standalone: true,
  imports: [CommonModule, TranslateModule], // Thêm TranslateModule
  templateUrl: "./vendor-page.component.html",
  styleUrl: "./vendor-page.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VendorPageComponent implements OnInit {
  suppliers: Supplier[] = [];

  constructor(
    private translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadSuppliers();
    // Tự động cập nhật lại danh sách khi đổi ngôn ngữ
    this.translate.onLangChange.subscribe(() => {
      this.loadSuppliers();
    });
  }

  loadSuppliers(): void {
    this.translate.get('VENDORS.ITEMS').subscribe((items: Supplier[]) => {
      this.suppliers = items;
      this.cdr.markForCheck();
    });
  }

  trackById(_: number, item: Supplier): number {
    return item.id;
  }
}